__turbopack_context__.v({
  "background-image": "styles-module__gBdsLa__background-image",
  "background-image-wrapper": "styles-module__gBdsLa__background-image-wrapper",
  "everything-wrapper": "styles-module__gBdsLa__everything-wrapper",
  "text-content-wrapper": "styles-module__gBdsLa__text-content-wrapper",
});
